export const HRIS_ACCESS_RIGHTS = {

  //#region DASHBOARDS
  HRIS_DASHBOARD_EMPLOYEES: 4001,
  //#endregion

  //#region EMPLOYEES
  HRIS_EMPLOYEES: 4101,
  HRIS_EMPLOYEES_PERSONALINFORMATION: 4102,
  HRIS_EMPLOYEES_MEDICALINFORMATION: 4103,
  HRIS_EMPLOYEES_WORKINFORMATION: 4104,
  HRIS_EMPLOYEES_SALARYINFORMATION: 4105,
  HRIS_EMPLOYEES_BANKINFORMATION: 4106,
  HRIS_EMPLOYEES_SERVICERECORDS: 4107,
  HRIS_EMPLOYEES_PERSONALDATASHEET: 4108,
  HRIS_EMPLOYEES_EMPLOYEELOGS: 4109,
  HRIS_EMPLOYEES_EMPLOYEEFILES: 4110,
  //#endregion

  //#region STATIC DATA
  HRIS_STATICDATA_EDUCATIONLEVELS: 4501,
  HRIS_STATICDATA_EMPLOYMENTTYPES: 4502,
  HRIS_STATICDATA_HOLIDAYTYPES: 4503,
  HRIS_STATICDATA_LEAVETYPES: 4504,
  HRIS_STATICDATA_NATIONALITIES: 4505,
  HRIS_STATICDATA_OFFICES: 4506,
  HRIS_STATICDATA_POSITIONS: 4507,
  HRIS_STATICDATA_RELATIONSHIPTYPES: 4508,
  HRIS_STATICDATA_SALARYMATRIX: 4509,
  HRIS_STATICDATA_SALARYTYPES: 4510,
  HRIS_STATICDATA_SCHOOLS: 4511,
  HRIS_STATICDATA_SEPARATIONTYPES: 4512,
  HRIS_STATICDATA_SEPARATIONTYPECATEGORIES : 4512,
  HRIS_STATICDATA_SERVICERECORDTYPES: 4513,
  HRIS_STATICDATA_SKILLS: 4514,
  HRIS_STATICDATA_TRAININGPROGRAMS: 4515,
  HRIS_STATICDATA_TRAININGTARGETS: 4516,
  HRIS_STATICDATA_WORKSCHEDULES: 4517,
  //#endregion

  //#region TRANSACTIONS 
  HRIS_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_VIEWER: 4601,
  HRIS_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_REQUESTOR: 4602,
  HRIS_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_APPROVER: 4603,
  HRIS_TRANSACTIONS_201FILECOPY_VIEWER: 4604,
  HRIS_TRANSACTIONS_201FILECOPY_REQUESTOR: 4605,
  HRIS_TRANSACTIONS_201FILECOPY_APPROVER: 4606,
  HRIS_TRANSACTIONS_LEAVE_VIEWER: 4607,
  HRIS_TRANSACTIONS_LEAVE_REQUESTOR: 4608,
  HRIS_TRANSACTIONS_LEAVE_APPROVER: 4609,
  HRIS_TRANSACTIONS_OVERTIME_VIEWER: 4610,
  HRIS_TRANSACTIONS_OVERTIME_REQUESTOR: 4611,
  HRIS_TRANSACTIONS_OVERTIME_APPROVER: 4612,
  HRIS_TRANSACTIONS_SERVICERECORDCOPY_VIEWER: 4613,
  HRIS_TRANSACTIONS_SERVICERECORDCOPY_REQUESTOR: 4614,
  HRIS_TRANSACTIONS_SERVICERECORDCOPY_APPROVER: 4615,
  HRIS_TRANSACTIONS_TRAINING_VIEWER: 4616,
  HRIS_TRANSACTIONS_TRAINING_REQUESTOR: 4617,
  HRIS_TRANSACTIONS_TRAINING_APPROVER: 4618,
  HRIS_TRANSACTIONS_WORKFROMHOME_VIEWER: 4619,
  HRIS_TRANSACTIONS_WORKFROMHOME_REQUESTOR: 4620,
  HRIS_TRANSACTIONS_WORKFROMHOME_APPROVER: 4621,
  //#endregion

};